import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { getRequest } from 'utils/api';
import { closeModal, setFromDiscover } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import useModalData from 'hooks/useModalData';
import Profile from './Profile';
import TransitionDialog from 'components/TransitionDialog';
import FullScreenCircularLoader from 'components/FullScreenCircularLoader';

const useStyles = makeStyles(theme => ({
  sidePaperFullScreenDialog: {
    [theme.breakpoints.up('md')]: {
      width: '85%',
      marginLeft: 'auto',
    },

    [theme.breakpoints.up('lg')]: {
      width: '65%',
      marginLeft: 'auto',
    },

    [theme.breakpoints.up('xl')]: {
      width: '45%',
      marginLeft: 'auto',
    },
  },

  sidePaper: {
    width: '100%',
    backgroundColor: '#f8f9fb',
    marginLeft: 'auto',
  },
}));

const InfluencerProfileDialog = ({ gig, handleInvite }) => {
  const [profile, setProfile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const open = useModalOpen('Full Profile');
  const classes = useStyles();
  const { username, selectedNetworkIds } = useModalData('Full Profile');

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setFromDiscover(false));
    dispatch(closeModal('Full Profile'));
  };

  useEffect(() => {
    setIsLoading(true);
    if (!username) return;

    getRequest({
      endpoint: `profiles/${username}/public_profile`,
      query: { as_advertiser: true },
    })
      .then(response => {
        setProfile(response);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [username]);

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      dialogStyles={classes.sidePaperFullScreenDialog}
      paperProps={{ className: classes.sidePaper }}
      direction="left"
      desktopDirection="left"
      noCloseIcon
    >
      {isLoading ? (
        <FullScreenCircularLoader />
      ) : (
        <Profile
          profile={profile}
          setProfile={setProfile}
          handleClose={handleClose}
          selectedNetworkIds={selectedNetworkIds}
          handleInvite={handleInvite}
          gig={gig}
          isDialog
        />
      )}
    </TransitionDialog>
  );
};

export default InfluencerProfileDialog;
